const parseQueryOptions = (query) => {
  let sortBy = [];
  let sortDesc = [];

  if (query.ordering && query.ordering.startsWith('-')) {
    sortBy = [query.ordering.substring(1).replaceAll('__', '.')];
  } else if (query.ordering) {
    sortBy = [query.ordering.replaceAll('__', '.')];
    sortDesc = [true];
  }
  const params = { sortBy, sortDesc };

  if (query.page) {
    params.page = Number(query.page);
  }
  if (query.page_size) {
    params.itemsPerPage = Number(query.page_size);
  }
  return params;
};

const getQueryParams = (options) => {
  const params = {};
  if (options.page) {
    params.page = options.page;
  }
  if (options.itemsPerPage) {
    params.page_size = options.itemsPerPage;
  }
  if (options.sortBy.length === 1) {
    params.ordering = options.sortBy[0].replaceAll('.', '__');

    if (options.sortDesc.length === 1) {
      if (options.sortDesc[0] === false) {
        params.ordering = `-${options.sortBy[0].replaceAll('.', '__')}`;
      }
    }
  }
  return params;
};

export {
  parseQueryOptions,
  getQueryParams,
};
